import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Package, Repeat, Zap, Wallet } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();

  const navItems = [
    {
      label: t('nav.home'),
      path: '/dashboard',
      icon: <Home size={20} />
    },
    {
      label: t('nav.packs'),
      path: '/packs',
      icon: <Package size={20} />
    },
    {
      label: t('nav.trade'),
      path: '/spot',
      icon: <Repeat size={22} />,
      special: true
    },
    {
      label: t('nav.futures'),
      path: '/futures',
      icon: <Zap size={20} />
    },
    {
      label: t('nav.wallet'),
      path: '/wallet',
      icon: <Wallet size={20} />
    }
  ];

  // Only show on mobile
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[100] px-4 pb-6 pt-2 bg-slate-950/90 backdrop-blur-2xl border-t border-white/5 shadow-[0_-10px_40px_rgba(0,0,0,0.8)]">
      <div className="max-w-md mx-auto flex items-end justify-between relative">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          
          if (item.special) {
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className="flex flex-col items-center group -mt-10 relative z-10"
              >
                <div className={`w-11 h-11 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-2xl ${
                  isActive 
                    ? 'bg-indigo-500 text-white shadow-indigo-500/50 rotate-[10deg] scale-110' 
                    : 'bg-gradient-to-br from-indigo-600 to-indigo-700 text-white shadow-indigo-900/40 hover:scale-105'
                }`}>
                  <div className={isActive ? 'animate-pulse' : ''}>
                    {item.icon}
                  </div>
                </div>
                <span className={`mt-2 text-[9px] font-black uppercase tracking-[0.15em] transition-colors duration-300 ${
                  isActive ? 'text-white' : 'text-slate-500'
                }`}>
                  {item.label}
                </span>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className="flex flex-col items-center px-2 py-1 group relative transition-all duration-300"
            >
              <div className={`transition-all duration-500 w-5 h-5 flex items-center justify-center ${
                isActive 
                  ? 'scale-110 -translate-y-1 drop-shadow-[0_0_8px_rgba(99,102,241,0.8)]' 
                  : 'opacity-60 group-hover:opacity-100'
              }`}>
                {item.img ? <img src={item.img} alt={item.label} className="w-full h-full object-cover scale-125" style={{ WebkitMaskImage: 'radial-gradient(circle, black 40%, transparent 80%)', maskImage: 'radial-gradient(circle, black 40%, transparent 80%)' }} /> : item.icon}
              </div>
              <span className={`mt-1.5 text-[9px] font-black uppercase tracking-[0.1em] transition-colors duration-300 ${
                isActive ? 'text-indigo-400' : 'text-slate-500 group-hover:text-slate-300'
              }`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute -bottom-1 w-1 h-1 rounded-full bg-indigo-400 shadow-[0_0_12px_rgba(99,102,241,1)] animate-pulse" />
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
